import type { JSX } from 'react'

export const EditIcon = (): JSX.Element => (
  <use href='#editIcon' height='100%' width='100%' />
)
